
<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
  <symbol id="wordfile" viewBox="0 0 384 512">
    <path fill="#ffffff" d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z" />
  </symbol>

  <symbol id="gear" viewBox="0 0 512 512">
    <path fill="#ffffff" d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
  </symbol>

  <symbol id="calendar" viewBox="0 0 512 512">
    <path fill="#ffffff" d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
  </symbol>

  <symbol id="failure" viewBox="0 0 512 512">
    <path fill="#ffffff" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
  </symbol>

  <symbol id="html-file" viewBox="0 0 512 512">
    <path fill="#ffffff" d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" />
  </symbol>

  <symbol id="user-check" viewBox="0 0 512 512">
    <path fill="#183153" d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
  </symbol>

  <symbol id="failed_task" viewBox="0 0 512 512">
    <path fill="#c21919" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
  </symbol>

  <symbol id="completed_task" viewBox="0 0 512 512">
    <path fill="#2ca01c" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
  </symbol>

  <symbol id="cloud" viewBox="0 0 640 512">
    <path fill="#235190" d="M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z" />
  </symbol>

</svg>

<div class="col-lg-12 shadow-lg mt-n2" id="div-scroll">

  <div class="row row-cols-1 row-cols-md-5 mb-1 pt-1 text-center">
    <div class="col">
      <div class="card mb-4 rounded-3 mf-booking shadow-sm">
        <div class="card-header d-flex bg-success py-2">
          <svg class="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em"><use xlink:href="#wordfile" /></svg>
          <h4 class="my-0 fw-normal">WIP</h4>
        </div>
        <div id="Booking_card" class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap card-sel">
          <h1 id="Summary_Booking_count" class="pricing-card-title mt-2 ml-4 mr-1">0</h1>
          <button type="button" (click)="Show_Card_Details('Booking')" class="btn btn-sm btn-outline-success p-2 ml-5 mr-2">View List</button>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="card mb-4 rounded-3 mf-inprocess shadow-sm">
        <div class="card-header d-flex bg-info py-2">
          <svg class="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em"><use xlink:href="#gear" /></svg>
          <h4 class="my-0 fw-normal">Auto Structure</h4>
        </div>
        <div id="AutoStructure_card" class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap">
          <h1 id="Summary_inprocess_count" class="pricing-card-title mt-2 ml-4 mr-1">0</h1>
          <button type="button" (click)="Show_Card_Details('AutoStructure')" class="btn btn-sm btn-outline-info p-2 ml-5 mr-2">View List</button>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card mb-4 rounded-3 mf-warning shadow-sm">
        <div class="card-header d-flex bg-warning py-2">
          <svg class="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em"><use xlink:href="#calendar" /></svg>
          <h4 class="my-0 fw-normal">Over Due</h4>
        </div>
        <div id="OverDue_card" class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap">
          <h1 id="Summary_overdue_count" class="pricing-card-title mt-2 ml-4 mr-1">0</h1>
          <button type="button" (click)="Show_Card_Details('OverDue')" class="btn btn-sm btn-outline-warning p-2 ml-5 mr-2">View List</button>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card mb-4 rounded-3 mf-danger shadow-sm">
        <div class="card-header d-flex bg-danger py-2">
          <svg class="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em"><use xlink:href="#failure" /></svg>
          <h4 class="my-0 fw-normal">Failure</h4>
        </div>
        <div id="Failure_card" class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap">
          <h1 id="Summary_failure_count" class="pricing-card-title mt-2 ml-4 mr-1">0</h1>
          <button type="button" (click)="Show_Card_Details('Failure')" class="btn btn-sm btn-outline-danger p-2 ml-5 mr-2">View List</button>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card mb-4 rounded-3 mf-proofing shadow-sm">
        <div class="card-header d-flex bg-secondary py-2">
          <svg class="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em"><use xlink:href="#html-file" /></svg>
          <h4 class="my-0 fw-normal">PreEditing</h4>
        </div>
        <div id="PreEdit_card" class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap">
          <h1 id="Summary_proofing_count" class="pricing-card-title mt-2 ml-4 mr-1">0</h1>
          <button type="button" (click)="Show_Card_Details('PreEdit')" class="btn btn-sm btn-outline-secondary p-2 ml-5 mr-2">View List</button>
        </div>
      </div>
    </div>
  </div>

  <button type="button" id="btnUploadDT" (click)="fileMSUpload.click()" style="display:none">Upload</button>
  <button type="button" id="btnLoadList" (click)="get_Manuflow_ArticleList()" style="display:none">Get</button>
  <button type="button" id="btnReportView" class="btn btn-block btn-primary float-sm-right" (click)="Show_Manuflow_HtmlReport()" style="display:none">Report View</button>
  <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>

  <button type="button" id="btnDocDownload" class="btn btn-block btn-primary float-sm-right" style="display:none">Doc Download</button>
  <button type="button" id="btnDocUpload" class="btn btn-block btn-primary float-sm-right" style="display:none">Doc Upload</button>
  <button type="button" id="btnDocMerge" class="btn btn-block btn-primary float-sm-right" (click)="Show_DocFileMerge()" style="display:none">Doc Merge</button>
  <button type="button" id="btnHtmlDownload" class="btn btn-block btn-primary float-sm-right" style="display:none">Html Download</button>


  <div class="form-group" style="display:none">
    <label for="FU_ManuscriptUpload">Correction File</label>
    <div class="custom-file">
      <input type="file" #fileMSUpload id="FU_ManuscriptUpload" (change)="FileMSUploadChangeEvent($event)">
    </div>
  </div>
  <!--<div class="bd-heading sticky-xl-top align-self-start mt-3 mb-3 mt-xl-0 mb-xl-2 border-bottom ">
    <h3 id="Card-data-label">Booking</h3>
  </div>-->

  <div id="contentPane_Booking" data-val="contentPane" class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="divContainer">
            <div class="card">
              <div class="card-body">
                <table #dataTable class="display" style="width:100%"></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="contentPane_Nodatafound" data-val="contentPane" class="row row-cols-1 row-cols-md-1 mb-1 text-center">
    <div class="col">
      <table class="table table-bordered table-head-fixed ">
        <tbody>
          <tr><td>No records Found...</td></tr>
        </tbody>
      </table>
    </div>
  </div>

  <div id="contentPane_AutoStructure" data-val="contentPane" class="row row-cols-1 row-cols-md-2 mb-1 text-center">
  </div>

  <div class="autostruct_template">
    <div class="col">
      <div class="card mb-4 rounded-0 task-box">
        <div class="card-header row-cols-md-2 d-flex bg-list py-2">
          <div class="col w-100 d-flex align-items-start">
            <svg class="bi text-muted flex-shrink-0 me-2 ml-n2" width="1.75em" height="1.75em"><use xlink:href="#[taskicon]" /></svg>
            <h5 class="my-0 pt-1 fw-normal">[articleid]</h5>
          </div>
          <div class="col w-100 align-items-end">
            <h5 class="my-0 w-100 fw-normal pt-1 text-right">[articletitle]</h5>
          </div>
        </div>
        <div class="progress">
          <div class="progress-bar progress-bar-striped  progress-bar-animated bg-info" role="progressbar" aria-label="Segment two - animated striped success example" style="width: 100%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap">
          <table class="table table-bordered table-head-fixed">
            <thead>
              <tr>
                <th style="position:relative">PROCESS</th>
                <th style="position:relative">START TIME</th>
                <th style="position:relative">END TIME</th>
                <th style="position:relative">STATUS</th>
              </tr>
            </thead>
            <tbody>
              [tbodyContent]
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>


  <div class="assessment_report_template">
    <div class="col-sm-6">
      <div class="card mb-4 rounded-0 task-box">
        <div class="card-header row-cols-md-1 d-flex bg-list-report py-2">
          <div class="col w-100 d-flex align-items-start">
            <h5 class="my-0 pt-1 fw-normal">[headingtype]</h5>
          </div>
        </div>
        <div class="card-body btn-group w-100 align-items-center justify-content-between flex-wrap">
          <table class="table table-bordered table-head-fixed">
            <thead>
              <tr colspan="2">
                <th style="position:relative">Assessment Type</th>
                <th style="position:relative">Value</th>
              </tr>
            </thead>
            <tbody>
              [tbodyContent]
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="row">
    <div class="col-lg-12 mt-n2">

      <div class="form-group">

        <div id="DivActivityList" class="activityTable fixTableHead">
          <table id="tblmanuflow_ArticleList" class="table table-bordered table-head-fixed " data-select2-id="tblmanuflow_ArticleList">
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Journal</th>
                <th>Article ID</th>
                <th>Article title</th>
                <th>DOI</th>
                <th>Manuscript</th>
                <th>Article type</th>
                <th>Received date</th>
                <th>Scheduled date</th>
                <th>Due date</th>
                <th>Upload</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        </div>
      </div>


    </div>
  </div>-->
</div>


<!-- The Modal -->
<div class="modal" [style.display]="showModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <form #form="ngForm">
          <div class="row row-cols-1 row-cols-md-1 mb-1 text-center">
            <div class="col-12" id="divReport_Progress">
            </div>
            <div class="row row-cols-1 row-cols-md-3 mb-1 text-center col-sm-4 ml-1" id="divReport_data">
            </div>
          </div>
        </form>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopup">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
    </div>
  </div>

</div>


<!-- The Modal -->
<div class="modal" [style.display]="showModalDocList ? 'block' : 'none'">
  <div id="custom-file-merge" class="modal-dialog modal-xl custome-modal">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <form #form="ngForm">

          <div id="divDocFileList">
            <table id="Tbl-File-Merge" class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-center"><input id="chk_SelectAll" name="selecFileHead" type="checkbox"></th>
                  <th>File Name</th>
                  <th class="text-center">Merge Status</th>
                  <th class="text-center">Download</th>
                  <th class="text-center">Move(up/down)</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>No Records Found...</td></tr>
                <!--<tr>
                  <td class="text-center"><input type="checkbox" name="selectFile"></td>
                  <td>XYZ File-1</td>
                  <td>yes</td>
                  <td class="text-center"><span><i class="bx bx-download merge-download" title="download"></i></span></td>
                  <td class="text-center"><span class="btnup"><i class="bx bxs-up-arrow-circle" title="Up"></i></span><span class="btndown"><i class="bx bxs-down-arrow-circle" title="Down"></i></span></td>
                </tr>
                <tr>
                  <td class="text-center"><input type="checkbox" name="selectFile"></td>
                  <td>XYZ File-2</td>
                  <td>yes</td>
                  <td class="text-center"><span><i class="bx bx-download merge-download" title="download"></i></span></td>
                  <td class="text-center"><span class="btnup"><i class="bx bxs-up-arrow-circle" title="Up"></i></span><span class="btndown"><i class="bx bxs-down-arrow-circle" title="Down"></i></span></td>
                </tr>
                <tr>
                  <td class="text-center"><input type="checkbox" name="selectFile"></td>
                  <td>XYZ File-3</td>
                  <td>yes</td>
                  <td class="text-center"><span><i class="bx bx-download merge-download" title="download"></i></span></td>
                  <td class="text-center"><span class="btnup"><i class="bx bxs-up-arrow-circle" title="Up"></i></span><span class="btndown"><i class="bx bxs-down-arrow-circle" title="Down"></i></span></td>
                </tr>
                <tr>
                  <td class="text-center"><input type="checkbox" name="selectFile"></td>
                  <td>XYZ File-4</td>
                  <td>yes</td>
                  <td class="text-center"><span><i class="bx bx-download merge-download" title="download"></i></span></td>
                  <td class="text-center"><span class="btnup"><i class="bx bxs-up-arrow-circle" title="Up"></i></span><span class="btndown"><i class="bx bxs-down-arrow-circle" title="Down"></i></span></td>
                </tr>               
                
                <tr>
                  <td class="text-center"><input type="checkbox" name="selectFile"></td>
                  <td>XYZ File-5</td>
                  <td>yes</td>
                  <td class="text-center"><span><i class="bx bx-download merge-download" title="download"></i></span></td>
                  <td class="text-center"><span class="btnup"><i class="bx bxs-up-arrow-circle" title="Up"></i></span><span class="btndown"><i class="bx bxs-down-arrow-circle" title="Down"></i></span></td>
                </tr>-->
                
              </tbody>
            </table>
          </div>

        </form>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="MergeDocFiles()">Merge</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopup">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
    </div>
  </div>

</div>


